//import { LicencingModulePluginStore } from "./plugin-store";
import { tasksActions } from "./task/actions";
export const actions = {
 ...tasksActions 
};
